// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
